import React, {useRef} from "react";
import {css, Theme} from "@emotion/react";

import {Container} from "@pg-design/grid-module";
import {flexAbsoluteCenter, ml, mr, mt, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {useResponsiveLinkTarget} from "../../hooks/use_responsive_link_target";
import {useGetRankingPartnersQuery} from "../api/get_ranking_partners";
import {IRankingPartner} from "../types/IRankingPartner";
import {IRankingPartnerLogo} from "../types/IRankingPartnerLogo";

export const RankingPartners = () => {
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const {data: rankingPartnersResponse} = useGetRankingPartnersQuery();
    const partners = rankingPartnersResponse ? rankingPartnersResponse.results : [];

    const partnersRef = useRef(null);
    const validPartners = partners.filter((partner) => Boolean(partner.logo));

    if (!partners) {
        return null;
    }

    return (
        <Container css={rankingPartners}>
            <Text align="center" as="h2" variant="headline_3">
                Partnerzy rankingu inwestycji
            </Text>

            <div css={partnerList} ref={partnersRef}>
                {validPartners.map((partner: IRankingPartner) => {
                    return (
                        <a
                            key={partner.name}
                            href={partner.website}
                            rel={partner.follow_link ? "" : "nofollow"}
                            target={responsiveLinkTarget}
                            css={partnerHolder}
                        >
                            <img src={(partner.logo as IRankingPartnerLogo).p_log_155x75} width={155} height={75} alt={partner.name} css={image} />
                        </a>
                    );
                })}
            </div>
        </Container>
    );
};

const rankingPartners = (theme: Theme) => css`
    @media (max-width: ${theme.breakpoints.sm}) {
        position: relative;
        max-width: 100%;
        ${p(0)};
    }
`;

const partnerList = (theme: Theme) => css`
    display: flex;
    overflow: scroll;
    flex-wrap: nowrap;
    ${mt(4)};
    gap: 2.4rem;

    @media (min-width: ${theme.breakpoints.md}) {
        overflow: unset;
        flex-wrap: wrap;
        justify-content: center;
        ${mt(5)};
    }
`;

const partnerHolder = (theme: Theme) => css`
    ${flexAbsoluteCenter};
    cursor: pointer;
    min-width: 16.8rem;
    width: 16.8rem;
    height: 8.8rem;

    @media (max-width: ${theme.breakpoints.sm}) {
        &:first-of-type {
            ${ml()};
        }

        &:last-of-type {
            ${mr()};
        }
    }
`;

const image = css`
    height: auto;
`;
